import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import classnames from 'classnames';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import enviroment from '../../../enviroments/enviroment';
import { useUserMe } from '../../../commons/hooks/userme';
import {
    EEmail,
    EPassword,
    EErrorMsg,
} from '../../../commons/statics/controls';
import { AppContext } from '../../../commons/context/App-context';
import Recaptcha from '../../../commons/components/recaptcha/Recaptcha';
import './login.scss';

interface ILogin {
    email: string;
    password: string;
}

const Login = () => {
    const history = useHistory();
    const { isLoading, changeIsLoading } = useContext(AppContext);
    const [msgError, setMsgError] = useState('');
    const { register, handleSubmit, formState } = useForm({
        mode: 'onChange',
    });
    const { errors, isDirty, isValid } = formState;
    const [userMe, setUserMe] = useUserMe();

    const handleOnSubmit = (u: ILogin) => {
        const { email, password } = u;
        changeIsLoading(true);
        setMsgError('');

        if (email && password) {
            axios
                .post(enviroment.apiURL + '/login', {
                    username: email,
                    password,
                })
                .then((res: any) => {
                    const { err, token } = res?.data || {};
                    changeIsLoading(false);
                    if (err) {
                        setMsgError(err);
                    } else {
                        (async () => {
                            await setUserMe({
                                ...userMe,
                                token,
                            });
                        })();
                        history.push('/');
                    }
                })
                .catch(() => {
                    changeIsLoading(false);
                    setMsgError(EErrorMsg.generic);
                    setUserMe.reset();
                });
        } else {
            changeIsLoading(false);
            setMsgError(EErrorMsg.dataForm);
        }
    };

    const handleBackLanding = () => {
        window.open('https://rpp.pe/empresasquetransforman', '_self');
    };

    return (
        <Recaptcha>
            <div className="LoginWrapFull">
                <div
                    className="LoginBanner"
                    style={{
                        backgroundImage:
                            'url(/images/login-left.png)',
                    }}
                ></div>
                <div className="LoginWrap">
                    <form
                        onSubmit={handleSubmit(handleOnSubmit)}
                        className="LoginWrapInner"
                    >
                        <div className="LoginLogo">
                            <img
                                alt="Empresas que transforman el Perú"
                                src="/images/logo.png"
                                onClick={handleBackLanding}
                            />
                        </div>
                        <div className="LoginWrapForm">
                            <div className="mbm">
                                <label
                                    className={classnames({
                                        label: true,
                                        invalid: errors?.email,
                                    })}
                                    htmlFor="email"
                                >
                                    Correo electrónico
                                </label>
                                <input
                                    className={classnames({
                                        input: true,
                                        invalid: errors?.email,
                                    })}
                                    id="email"
                                    type="text"
                                    placeholder="Ingresa tu correo electrónico"
                                    maxLength={EEmail.maxLength}
                                    {...register('email', {
                                        required: {
                                            value: true,
                                            message: 'Email es requerido.',
                                        },
                                        pattern: {
                                            value: EEmail.pattern,
                                            message:
                                                'Ingresa un Mail corporativo válido.',
                                        },
                                        minLength: {
                                            value: EEmail.minLength,
                                            message:
                                                'Min. ' +
                                                EEmail.minLength +
                                                ' caracteres.',
                                        },
                                        maxLength: {
                                            value: EEmail.maxLength,
                                            message:
                                                'Max. ' +
                                                EEmail.maxLength +
                                                ' caracteres.',
                                        },
                                    })}
                                />
                                <div className="helpText invalid">
                                    {errors?.email && errors?.email?.message}
                                </div>
                            </div>
                            <div className="mbm">
                                <label
                                    className={classnames({
                                        label: true,
                                        invalid: errors.password,
                                    })}
                                    htmlFor="password"
                                >
                                    Contraseña
                                </label>
                                <input
                                    className={classnames({
                                        input: true,
                                        invalid: errors.password,
                                    })}
                                    id="password"
                                    type="password"
                                    placeholder="Ingresa tu contraseña"
                                    maxLength={EPassword.maxLength}
                                    {...register('password', {
                                        required: {
                                            value: true,
                                            message: 'Contraseña es requerida.',
                                        },
                                        minLength: {
                                            value: EPassword.minLength,
                                            message:
                                                'Min. ' +
                                                EPassword.minLength +
                                                ' caracteres.',
                                        },
                                        maxLength: {
                                            value: EPassword.maxLength,
                                            message:
                                                'Max. ' +
                                                EPassword.maxLength +
                                                ' caracteres.',
                                        },
                                    })}
                                />
                                <div className="helpText invalid">
                                    {errors?.password &&
                                        errors?.password?.message}
                                </div>
                            </div>
                            <div className="mbm">
                                <Link className="small" to="/forgot-password">
                                    ¿Olvidaste tu contraseña?
                                </Link>
                            </div>
                            <div className="mb1">
                                <button
                                    className="button buttonFit"
                                    type="submit"
                                    disabled={isLoading || !isDirty || !isValid}
                                >
                                    Inicia sesión
                                </button>
                            </div>
                            <div className="mb1 small">
                                ¿Todavía no tienes cuenta?&nbsp;
                                <Link className="small fweight" to="/signup">
                                    Crea una cuenta
                                </Link>
                            </div>
                            {msgError && (
                                <div className="mb1 helpText invalid">
                                    {msgError}
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </Recaptcha>
    );
};

export default Login;
